import React from 'react'

interface UserAvatarProps {
  firstName?: string | null
  lastName?: string | null
  email?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  firstName,
  lastName,
  email,
  size = 'md',
  className = '',
}) => {
  // Función para obtener las iniciales
  const getInitials = (): string => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
    }
    if (firstName) {
      return firstName.substring(0, 2).toUpperCase()
    }
    if (email) {
      return email.substring(0, 2).toUpperCase()
    }
    return '??'
  }

  // Función para generar un color basado en el nombre/email
  const getColorFromString = (str: string): string => {
    const colors = [
      '#3E97FF', // primary
      '#50CD89', // success
      '#F1416C', // danger
      '#FFC700', // warning
      '#7239EA', // purple
      '#009EF7', // info
      '#F6851F', // orange
      '#17C653', // green
      '#E4E6EF', // gray
    ]
    
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    const index = Math.abs(hash) % colors.length
    return colors[index]
  }

  // Mapeo de tamaños
  const sizeClasses = {
    sm: 'symbol-35px',
    md: 'symbol-50px',
    lg: 'symbol-75px',
    xl: 'symbol-100px',
  }

  const fontSizes = {
    sm: 'fs-7',
    md: 'fs-5',
    lg: 'fs-3',
    xl: 'fs-1',
  }

  const initials = getInitials()
  const backgroundColor = getColorFromString(firstName || lastName || email || 'default')

  return (
    <div className={`symbol ${sizeClasses[size]} ${className}`}>
      <div
        className={`symbol-label ${fontSizes[size]} fw-bold text-white`}
        style={{backgroundColor}}
      >
        {initials}
      </div>
    </div>
  )
}
